export default __webpack_public_path__ + "static/media/popup_close.61bd2900.svg";